/**
 * stationeryPaper — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const stationeryPaperPack: ToilePack = {
    slug: 'stationery-paper',
    category: 'stationery',
    name: 'Stationery paper',
    tagline: tagline('sheets', 'layouts', 'styles'),
    chips: chips('layouts', 'styles'),
    ratio: A4,
    readings: [
        {key: 'floral', label: 'Floral border', subject: 'a garland of blooms and leaves around all four edges'},
        {key: 'airmail', label: 'Vintage airmail', subject: 'a chevron border, a postmark ring and a stamp box'},
        {key: 'header', label: 'Minimalist header', subject: 'one slim band across the top and a hairline rule'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'soft washes with feathered edges', palette: 'hand-painted on warm white', framing: 'full page, middle left blank for writing'},
        {key: 'retro', label: 'Retro print', style: 'flat offset color, slight misregistration', palette: 'faded mid-century, halftone grain', framing: 'full page, middle left blank for writing'},
        {key: 'clean', label: 'Modern clean', style: 'crisp vector shapes, nothing decorative', palette: 'a single accent on bright white', framing: 'full page, wide margins, middle left blank'},
    ],
    directions: ['a nautical border instead', 'in dusty blue', 'with faint writing lines'],
}
